<script setup lang="ts">
// Vue
import { computed, watch, onMounted } from "vue";

// Data Providers
import { useClassificationTypes } from "@/dataProviders/ClassificationTypes";

// GraphQL
import { useGetClassificationTypesLazyQuery, Country_Enum } from "@/graphql";

// Components
import GraphQLError from "@/features/GraphQLError";

// ///////////////////
// Props
// ///////////////////

const props = defineProps<{
  country: Country_Enum | null;
}>();

// ///////////////////
// Data Providers
// ///////////////////

const classificationTypes = useClassificationTypes();

// ///////////////////
// Variables
// ///////////////////

const queryVariables = computed(() => ({
  country: props.country as Country_Enum,
}));

// ///////////////////
// Query
// Default values are Denmark and BIMTypeCode
// ///////////////////

const { result, loading, error, refetch, load } = useGetClassificationTypesLazyQuery(
  props.country ? queryVariables.value : { country: Country_Enum.DENMARK },
  {
    fetchPolicy: "no-cache",
  }
);

// ///////////////////
// Lifecycle
// ///////////////////

onMounted(() => {
  load();
});

// ///////////////////
// Watchers
// ///////////////////

watch(
  () => props.country,
  (newValue) => {
    if (newValue) {
      refetch(queryVariables.value);
    }
  }
);

watch(
  result,
  (newValue) => {
    if (newValue) {
      classificationTypes.mapData(newValue);
    }
  },
  { deep: true }
);

watch(loading, (newLoading) => {
  classificationTypes.setLoading(newLoading);
});
</script>

<template>
  <GraphQLError
    :error="error"
    name="ClassificationTypes" />
</template>
